/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CliniShift Manager
 * The CliniShift Manager API is used to manage the CliniShift platform. This API is used by the CliniShift Manager Portal.
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const NotificationActorSystem = zod.object({
  "type": zod.literal("system"),
  "display_name": zod.string()
});

export type NotificationActorSystem = zod.input<typeof NotificationActorSystem>;
export type NotificationActorSystemOutput = zod.output<typeof NotificationActorSystem>;
